import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

export default function NotFound() {
  return (
    <>
      <Navbar />
      <main className="pt-16 min-h-[60vh] flex items-center justify-center bg-background-50">
        <div className="text-center px-4">
          <div className="w-20 h-20 flex items-center justify-center rounded-full bg-background-100 mx-auto mb-6">
            <i className="ri-error-warning-line text-3xl text-foreground-400"></i>
          </div>
          <h1 className="text-4xl md:text-5xl font-bold font-heading text-foreground-900 mb-4">404</h1>
          <p className="text-base text-foreground-600 mb-8">抱歉，您访问的页面不存在</p>
          <Link
            to="/"
            className="inline-flex items-center px-6 py-3 rounded-full text-sm font-semibold bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors cursor-pointer"
          >
            <i className="ri-home-4-line mr-2"></i>
            返回首页
          </Link>
        </div>
      </main>
      <Footer />
    </>
  );
}